import { mainAPIUrl } from '../../../settings';

const baseURL = `${mainAPIUrl}/gservices_3/ss`;

/**
 * Reports a declined location to the backend for tracking
 * Endpoint: POST /gservices_3/ss/declined_location
 *
 * @param {Object} params - Declined location parameters
 * @param {string} params.orderId - Order ID
 * @param {Object} params.address - Address that was declined
 * @param {string} params.address.address1 - Street address
 * @param {string} params.address.locality - City
 * @param {string} params.address.state - State
 * @param {string} params.address.postcode - Postal code
 * @param {string} params.address.country - Country
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export const reportDeclinedLocation = async ({ orderId, address }) => {
  const url = `${baseURL}/declined_location`;

  try {
    const requestBody = {
      data: {
        orderId,
        addressData: {
          address: address.address1 || null,
          postcode: address.postcode || null,
          locality: address.locality || null,
          state: address.state || null,
          country: address.country || null,
        },
        type: 'smartsend',
      },
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    const json = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: json.error || json.message || `Failed to report declined location: ${response.status}`,
      };
    }

    return {
      success: true,
      data: json,
    };
  } catch (error) {
    console.error('Error reporting declined location:', error);
    return {
      success: false,
      error: 'Network error. Please check your connection and try again.',
    };
  }
};
